export default "__VITE_ASSET__f713d811__"